import {TextField} from '@material-ui/core';
import {withStyles} from '@material-ui/styles';

export default withStyles({
    root: {
        margin: '0px 32px',
        borderBottom: '1px solid #D0D0D0',     
        '& input, textarea': {            
            // borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            fontFamily: 'Assistant',
            fontSize: '16px',
            fontStretch: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            color: '#505050',
        },
        '& input::placeholder': {
            fontFamily: 'Assistant',
            fontSize: '12px',
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            color: '#565656'
        },
        '& label.Mui-focused': {
            color: '#1274E4',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#1274E4',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(208, 208, 208, 1)',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'rgba(238, 238, 238, 1)',
                borderRadius: '4px',
            },
            '&:hover fieldset': {
                borderColor: '#ABABAB',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#1274E4',
            },
        },
    },
})(TextField);